










































































import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import { newVirtualMachineService } from '@/components/new-virtual-machine/services/NewVirtualMachineService';
import { SshKey } from '@/interfaces/SshKey';
import { NewVirtualMachineData } from '@/interfaces/NewVirtualMachineData';

@Component({})
export default class TwoFA extends Vue {
  twoFAModalShown = false;

  onClose2FA() {
    this.twoFAModalShown = false;
  }
}
